<template>
    <b-nav-form>
        <vue-bootstrap-typeahead v-model="query"
            placeholder="Search members"
            :serializer="s => s.name"
            @hit="handleHit"
        :data="results"
        />
    </b-nav-form>
</template>
<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import { SearchMembers } from '@/gql/members/Members.gql';

export default {
    components: {
        VueBootstrapTypeahead
    },
    data () {
        return {
            query: '',
            results: []
        }
    },
    methods : {
        handleHit (member){
            this.query = '';
            this.$router.push({
                name:'MemberDetail',
                params:{
                    id:member.id
                }
            })
        }
    },
    watch : {
        async query () {
            if(this.query.length < 3) {
                return false;
            }
            let data = await this.$apollo.query({
                query: SearchMembers,
                variables: {
                    query: (this.query) + '%'
                }
            });
            this.results = data.data.members;
        }
    }
}

</script>
